import * as React from "react";
import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { TimePointProjectUsers } from "./model";
import { getTotalWorkedByProjectUsers, postTimeWorkClose } from "./service";
import { filterById, filterIsChecked, generatorObjTimeWorkClosed } from "./lib";
import { ModalMessageSelectMonth } from "./components/ModalMessage/modalMessageSelectMonth";
import TableComponent from "./components/Table";
import { RoutineAppointmentProvider } from "./store";
import useRoutineAppointment from "./store/useRoutineAppointment";
import ModalError from "./components/ModalMessage/modalErrorMessage";
import useAuthData from "../../hook/useAppData";
import { convertDate, currentDate, dateFromInitial, dateMonthAndYear, dateToInitial, splitFormartDate, _formatDate } from "../../libs/dateUtils";
import { orderByName } from "../../libs/orderList";
import { toastSuccess, toastWarn } from "../../components/Toast";
import Input from "../../components/Input";
import { serviceUsers } from "../Collaborator/service";
import "./index.scss";
import InputSelect from "../../components/Input-select";
import { service } from "../Project/service/service";
import { FormControlLabel } from "@material-ui/core";
import { SwitchBlue } from "../../libs/switch";
import { ModalPopUp } from "../../components/ModalPopUp";
import { IconFilter } from "../../icons";
import Button from "../../components/Button";
import Title from "../../components/Title";
import { ACCESS } from "../Profile/constants";

export default function RoutineAppointment() {
  return (
    <RoutineAppointmentProvider>
      <RoutineAppointmentComponent />
    </RoutineAppointmentProvider>
  );
}

function RoutineAppointmentComponent() {
  const { token, profileId, accessIds } = useAuthData();
  const { initialValue, selectProject, setRows, setSelectProject, stateSwitch, setStateSwitch } = useRoutineAppointment();

  const [filterCollaborator, setFilterCollaborator] = useState(0);
  const [filterProject, setFilterProject] = useState(0);

  const [dateFrom, setDateFrom] = useState(_formatDate(dateFromInitial));
  const [dateTo, setDateTo] = useState(_formatDate(dateToInitial));
  const [monthAndYear, setMonthAndYear] = useState(dateMonthAndYear);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalError, setModalError] = useState(false);
  const [modalFilters, setModalFilters] = useState(false);

  const [users, setUsers] = useState();

  const [listProject, setListProject] = useState([] as any);
  const [listUsers, setListUsers] = useState([]);

  const [emptyFilter, setEmptyFilter] = useState(false);

  useEffect(() => {
    getFilterTotalWork(token, dateFrom, dateTo);
    getProject();
    getUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getProject() {
    const data = await service.getProjects(token);
    const orderData = orderByName(data, "name");
    setListProject(orderData);
  }

  async function getUser() {
    const data = await serviceUsers.getUsers(token);
    const orderData = orderByName(data, "name");
    setListUsers(orderData);
  }

  function notFoundList(data: any) {
    if (!data?.length) return setEmptyFilter(true);
    return setEmptyFilter(false);
  }

  function getFilterTotalWork(token: string, dataFrom: string, dataTo: string, userId?: number, projectId?: number) {
    getTotalWorkedByProjectUsers(token, dataFrom, dataTo, userId, projectId).then((data: TimePointProjectUsers[]) => {
      notFoundList(data);
      if (!data?.length) return;
      const dataOrder = orderByName(data, "userName");
      setRows(dataOrder);
    });
  }

  function handlePostTimeWork(splitFormartDate: any) {
    const newInitialValue: TimePointProjectUsers[] = filterIsChecked(initialValue);
    if (!newInitialValue?.length) return toastWarn("Selecione um profissional!");
    const data = generatorObjTimeWorkClosed(newInitialValue, splitFormartDate);
    postTimeWorkClose(token, data).then((data: any) => {
      if (data.timesWorkBlocked?.length) return handleApiError(data);
      handleApiSucess();
    });
  }

  function handleSubmitChecked() {
    const splitFormartDateFrom = splitFormartDate(dateFrom);
    const splitFormartDateTo = splitFormartDate(dateTo);
    if (splitFormartDateFrom[1] === splitFormartDateTo[1]) return handlePostTimeWork(splitFormartDateFrom);
    setModalStatus(!modalStatus);
  }

  function handleFilterClick() {
    const userId = filterCollaborator;
    const projectId = filterProject;
    projectId ? setSelectProject(true) : setSelectProject(false);
    getFilterTotalWork(token, dateFrom, dateTo, userId, projectId);
    setModalFilters(false);
  }

  function handleToCleanFilter() {
    setFilterCollaborator(0);
    setFilterProject(0);

    getFilterTotalWork(token, dateFrom, dateTo);
  }

  return (
    <>
      <Toaster />
      <div className="box-header">
        <Title title="Consolidação de Horas">
          <Button onClick={() => setModalFilters(true)} className="bg-secondary flex-row flex">
            <span>{IconFilter}</span> Filtros
          </Button>
          {accessIds?.includes(ACCESS.ROUTINE_APPOINTMENT_consolidate) && (
            <Button className="whitespace-nowrap w-auto bg-primary flex-row flex" onClick={() => handleSubmitChecked()}>
              Consolidar para aprovação
            </Button>
          )}
        </Title>
        {/* <div className="title-routine-appoiment titleContainer box-title">
          <h1>Consolidação de Horas</h1>
          <div className="flex gap">
            <button onClick={() => setModalFilters(true)} className="btn bg-secondary gap">
              <span className="icon-filter-routine-appoiment flex center">{IconFilter}</span> Filtros
            </button>
            {profileId === 1 && (
              <button type="button" className="Link btn bg-primary" onClick={() => handleSubmitChecked()}>
                Consolidar para aprovação
              </button>
            )}
          </div>
        </div> */}
        {modalError && <ModalError users={users} exit={setModalError} />}
        <ModalMessageSelectMonth
          text={`O periodo de ${convertDate(dateFrom)} à ${convertDate(dateTo)} possui meses diferente, qual mês você deseja fazer a consolidação?`}
          monthAndYear={monthAndYear}
          onClickCancel={setModalStatus}
          onClickConfirm={handleSubmitModal}
          setMonthAndYear={setMonthAndYear}
          status={modalStatus}
        />
        <ModalPopUp
          title="Filtros"
          status={modalFilters}
          onClickCancel={() => {
            setModalFilters(false);
          }}
          className="modal-filter-routine-appoiment"
        >
          <div className="filter-modal-content-routine-appoiment gap20">
            <div className="rowFilterContainer ">
              <InputSelect
                className="inputContainer"
                name="search"
                label="Profissional"
                placeholder="Pesquisar"
                onChange={(event: any) => {
                  setFilterCollaborator(event.target.value);
                }}
                value={filterCollaborator}
                list={listUsers}
              />
              <InputSelect
                className="inputContainer"
                name="search"
                label="Projeto"
                placeholder="Pesquisar"
                onChange={(event: any) => {
                  setFilterProject(event.target.value);
                }}
                value={filterProject}
                list={listProject}
              />
              <Input
                setValue={(event: any) => setDateFrom(event.target.value)}
                value={dateFrom}
                name="date"
                label="Data inicial"
                className="form-input inputContainer teste45"
                type="date"
                placeholder="Digite o período"
              />
              <Input
                setValue={(event: any) => setDateTo(event.target.value)}
                value={dateTo}
                name="date"
                label="Data final"
                className="form-input inputContainer teste45"
                type="date"
                placeholder="Digite o período"
              />
            </div>
            <div className="action-filter-routine-appoiment flex between">
              <div className="btn-filter-routine-appoiment flex btnContainer">
                <button className="btn filter-btn box-shadow bg-primary" onClick={handleFilterClick}>
                  Filtrar
                </button>
                <button className="Link btn bg-secondary box-shadow" onClick={handleToCleanFilter}>
                  Limpar
                </button>
              </div>
              <div className="switch-filter-routine-appoiment flex gap">
                <FormControlLabel
                  control={<SwitchBlue checked={stateSwitch} onChange={() => setStateSwitch(!stateSwitch)} name="checkedB" />}
                  label={`${stateSwitch ? "Consolidado" : "Não Consolidado"}`}
                  labelPlacement="start"
                />
                {/* <FormControlLabel
                  control={
                    <FormControlLabel
                      control={<SwitchBlue checked={stateSwitch} onChange={() => setStateSwitch(!stateSwitch)} name="checkedB" />}
                      label={`${stateSwitch ? "Consolidado" : "PJ"}`}
                      labelPlacement="end"
                    />
                  }
                  label={`${stateSwitch ? "Consolidado" : "CLT"}`}
                  labelPlacement="start"
                /> */}
              </div>
            </div>
          </div>
        </ModalPopUp>

        {emptyFilter === false ? (
          <>
            <TableComponent
              selectProject={selectProject}
              dateFrom={dateFrom}
              dateTo={dateTo}
              checkboxSelection={accessIds?.includes(ACCESS.ROUTINE_APPOINTMENT_consolidate)}
              details={true}
            />
          </>
        ) : (
          <div className="nothing-list box-form box-shadow table-container-full">
            <h1>Não há registros para a busca realizada.</h1>
          </div>
        )}
      </div>
    </>
  );

  function handleSubmitModal() {
    const splitFormartDateFrom = splitFormartDate(monthAndYear);
    handlePostTimeWork(splitFormartDateFrom);
    setModalStatus(false);
  }

  function handleApiSucess() {
    getFilterTotalWork(token, dateFrom, dateTo);
    toastSuccess("Sucesso na consolidação das horas!");
  }

  async function handleApiError(data: any) {
    const userPromise = data.timesWorkBlocked?.map((data: any) => {
      return displayErrorByIdUser(data);
    });
    const user = await getUsers(userPromise);
    setUsers(user);
    setModalError(true);
  }

  function getUsers(user: any) {
    const array: any = [];
    user?.map((user: any) => {
      user.then((data: any) => array.push(data));
    });
    return array;
  }

  async function displayErrorByIdUser(data: any) {
    return await serviceUsers.getUsersById(token, data.userId);
  }
}
